import type { ChunkAckMessage, ChunkMessage } from '../shared/websocket/ChunkMessages';
import { ChunkReceiver } from './ChunkReceiver';
import { ChunkSender } from './ChunkSender';

export class ChunkManager {
  protected chunkSenders = new Map<string, ChunkSender>();

  protected chunkReceivers = new Map<string, ChunkReceiver>();

  public sendChunkedMessage(message: any, sendChunk: (msg: ChunkMessage) => void) {
    const sender = new ChunkSender({
      message,
      sendChunk,
    });

    sender.sendChunks();

    this.chunkSenders.set(sender.id, sender);
  }

  public onChunkAckReceived(message: ChunkAckMessage) {
    const sender = this.chunkSenders.get(message.id);

    if (sender) {
      sender.onChunkAck(message);

      if (sender.isCompleted) {
        sender.dispose();

        this.chunkSenders.delete(message.id);
      }
    }
  }

  public stopChunkSendProcess(id: string) {
    const sender = this.chunkSenders.get(id);

    if (sender) {
      sender.dispose();

      this.chunkSenders.delete(id);
    }
  }

  public onChunkedMessageReceived(
    message: ChunkMessage,
    sendChunkAck: (msg: ChunkAckMessage) => void,
    onMessageCompleted: (msg: any) => void,
  ) {
    let receiver = this.chunkReceivers.get(message.id);

    if (!receiver) {
      receiver = new ChunkReceiver({
        id: message.id,
        totalChunks: message.totalChunks,
        sendChunkAck,
      });

      this.chunkReceivers.set(message.id, receiver);
    }

    receiver.addChunk(message);

    if (receiver.message) {
      receiver.dispose();

      this.chunkReceivers.delete(message.id);

      onMessageCompleted(receiver.message);
    }
  }

  public stopChunkReceiveProcess(id: string) {
    const receiver = this.chunkReceivers.get(id);

    if (receiver) {
      receiver.dispose();

      this.chunkReceivers.delete(id);
    }
  }
}
